import React from "react";
import { Form, Select } from "antd";

import MediaListing from "./MediaListing";

const MediaSelector = Form.create()(
  class C extends React.Component {
    state = { mediaPath: "" };
    handlePathChangeRequested = (path) => this.setState({ mediaPath: path });
    handleObjectChosen = (objectInfo) => this.props.onSubmit(objectInfo);
    render() {
      const { user, licenseSet, form } = this.props;

      const { mediaPath } = this.state;

      return (
        <Form autoComplete="off" layout="vertical">
          {user.isAdmin && (
            <Form.Item label="License">
              {form.getFieldDecorator("licenseId", {
                validateTrigger: ["onBlur"],
                rules: [{ required: true, message: "Please select a license" }],
              })(
                <Select placeholder="Select a license">
                  <Select.Option value={null}>---</Select.Option>
                  {licenseSet.map(({ id, name }) => (
                    <Select.Option key={id} value={id}>
                      {name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          )}

          {(!user.isAdmin ||
            (user.isAdmin && form.getFieldValue("licenseId"))) && (
            <Form.Item>
              <MediaListing
                path={mediaPath}
                licenseId={form.getFieldValue("licenseId")}
                onPathChangeRequested={this.handlePathChangeRequested}
                onObjectChosen={this.handleObjectChosen}
              />
            </Form.Item>
          )}
        </Form>
      );
    }
  }
);

export default MediaSelector;
